import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  list as listModuleCourseCategories,
  get as getModuleCourseCategory,
  reset as resetModuleCourseCategory,
  update as updateModuleCourseCategory,
  set as setModuleCourseCategory,
  create as createModuleCourseCategory,
  remove as removeModuleCourseCategory,
} from '$redux/course-categories/actions';

import { Button } from '@material-ui/core';
import Title from 'ui/Title';
import Loading from '$routes/Loading';
import Failed from '$routes/Failed';

import Grid from './Grid';
import Editor from './Editor';

class ModuleCourseCategory extends React.Component {
  state = {
    editorOpen: false,
    editorAction: 'new',
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(listModuleCourseCategories());
  }

  onCreate = () => {
    const { dispatch, single } = this.props;
    dispatch(createModuleCourseCategory(single));
  }

  onUpdate = () => {
    const { dispatch, single } = this.props;
    dispatch(updateModuleCourseCategory(single.idCourseCategory, single));
  }

  set = (key, value) => {
    const { dispatch } = this.props;
    dispatch(setModuleCourseCategory(key, value));
  }

  openEditor = (id) => {
    const { dispatch } = this.props;
    if (id) {
      dispatch(getModuleCourseCategory(id));
      this.setState({ editorOpen: true, editorAction: 'edit' });
    } else {
      dispatch(resetModuleCourseCategory());
      this.setState({ editorOpen: true, editorAction: 'new' });
    }
  }

  removeModuleCourseCategory = (id) => {
    const { dispatch } = this.props;
    if (id) {
      dispatch(removeModuleCourseCategory(id));
    }
  }

  render() {
    const { data, single, loading } = this.props;

    if (loading) return <Loading />;
    if (!data) return <Failed />;

    const { editorOpen, editorAction } = this.state;

    return (
      <div>
        <Title>
          Categoria de Ciclos
          <Button onClick={() => this.openEditor()} size="small">Crear nueva categoria</Button>
        </Title>
        {
          editorOpen ? (
            <Editor
              action={editorAction}
              data={single}
              set={this.set}
              onSend={editorAction === 'new' ? this.onCreate : this.onUpdate}
              onClose={() => this.setState({ editorOpen: false })}
            />
          ) : null
        }
        <Grid
          data={data}
          loading={loading}
          onEdit={this.openEditor}
          removeItem={this.removeModuleCourseCategory}
        />
      </div>
    );
  }
}

ModuleCourseCategory.propTypes = {
  dispatch: PropTypes.func.isRequired,
  data: PropTypes.array,
  single: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
};

ModuleCourseCategory.defaultProps = {
  data: null,
};

export default connect(
  state => ({
    data: state.courseCategories.list,
    single: state.courseCategories.single,
    loading: state.courseCategories.loading,
  }),
)(ModuleCourseCategory);
